/**
 * O que a tela de entrada anuncia em cada domínio.
 *
 * O painel da Pharu (painel.pharu.com.br) usa as MESMAS telas de identidade
 * do ERP, mas é outro produto, para outro público. Ali a tela não pode dizer
 * "Pharu ERP" nem mostrar o nome de UMA marcenaria cliente: seria
 * anunciar que a gestão da plataforma mora dentro do produto vendido. Só a
 * marca e o chip mudam; o resto do layout é o mesmo.
 */
import { ehHostDoPainel } from "../../../utils/hostDoPainel";

// A tela é anterior ao login: não há empresa conhecida. O chip diz o que o
// produto é, nunca o nome de um cliente.
const CHIP_DO_ERP = "Gestão para marcenarias";

const MARCA_ERP = {
  ehPainel: false,
  nomeCurto: "Pharu",
  nomeProduto: "ERP",
  rotuloInicio: "Pharu ERP, início",
  chip: CHIP_DO_ERP,
  titulo: "Acessar o Pharu ERP",
  subtitulo: "Entre com seu e-mail e senha para abrir os painéis liberados para você.",
  quemAjuda: "ao administrador da sua marcenaria",
};

const MARCA_PAINEL = {
  ehPainel: true,
  nomeCurto: "Pharu",
  nomeProduto: "",
  rotuloInicio: "Painel da Pharu, início",
  chip: "Painel da plataforma",
  titulo: "Acessar o painel da Pharu",
  subtitulo: "Entre com seu e-mail e senha da equipe Pharu.",
  quemAjuda: "a um administrador da plataforma",
};

/** Lida em tempo de render (o host pode mudar em teste depois do import). */
export function marcaDaEntrada() {
  return ehHostDoPainel() ? MARCA_PAINEL : MARCA_ERP;
}
